/* USERS */
export const GET_ITEM_NOTES = "GET_ITEM_NOTES"
export const GET_ITEM_NOTES_SUCCESS = "GET_ITEM_NOTES_SUCCESS"
export const GET_ITEM_NOTES_FAIL = "GET_ITEM_NOTES_FAIL"